
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MenuBar from '@/components/MenuBar';
import InterviewCard from '@/components/interview/InterviewCard';
import { Interview } from '@/types/interview';
import { useLocalizedInterviewsByPerson } from '@/hooks/useLocalizedInterviews';

const PersonPage = () => {
  const { name } = useParams();
  const decodedName = name ? decodeURIComponent(name) : '';
  const { data: interviews, isLoading } = useLocalizedInterviewsByPerson(decodedName);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <MenuBar />
        <div className="max-w-4xl mx-auto p-4">
          <div className="animate-pulse">
            <div className="h-64 bg-gray-200 rounded-lg mb-4"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <MenuBar />
      <div className="max-w-4xl mx-auto p-4">
        <h1 className="text-2xl font-semibold mb-6">
          Intervjuer med: {decodedName}
        </h1>
        <div className="space-y-12">
          {interviews?.map((interview, index) => (
            <InterviewCard 
              key={interview.id} 
              {...interview}
              isReversed={index % 2 !== 0}
              articleNumber={index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PersonPage;
